<script lang="ts">
    import type {GridFieldValueWithOriginReference} from '../../../../lib/types';
    import GridFieldValue from 'shared/ui-widgets/grid/GridFieldValue.svelte';

    export let value: GridFieldValueWithOriginReference;
</script>

{#if value?.text}
    <GridFieldValue field={value} chipSize="xs" linkButtonPosition="left"/>
{/if}